import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerService } from 'src/app/core/services/spinner.service';
import { ClipboardService} from 'ngx-clipboard';

@Component({
  selector: 'app-copy-text-dialog',
  templateUrl: './copy-text-dialog.component.html',
  styleUrls: ['./copy-text-dialog.component.scss']
})
export class CopyTextDialogComponent implements OnInit {

  showFormError = false;
  errMsgStyle: any = { 'max-width': '500px' };
  instructionsStr: string;
  titleStr: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<CopyTextDialogComponent>,
      private translateService: TranslateService,
      private clipboardService: ClipboardService,
      private spinnerService: SpinnerService
  ) {}

  ngOnInit(): void {
    this.instructionsStr = this.data.instructionsStr;
    this.titleStr = this.data.titleStr;
  }

  onCancel() {
    this.dialogRef.close(false);
  }
  
  onCopy(){
    this.showFormError = false;
    let result = this.clipboardService.copyFromContent(this.data.copyStr);
    if ( result == true )
    {
      this.dialogRef.close(result);
    }
		else
    {
      this.showFormError = true;
    }
  }
}
